<template>
    <div class="revenue-detail">
        <div class="pc-content">
            <div v-if="!ifPublic" style="display:inline-block;width:392px;height:200px;position:absolute;left:50%;margin-left:-196px;top:50%;margin-top:-100px;">
                <div style="color:#000;font-size:20px;text-align:center;">密码访问数据报表</div>
                <a-input v-model="proPwd" style="height:48px;margin:32px 0 16px" placeholder="请输入6位数字密码" />
                <span @click="testPwd" style="background:rgba(24, 144, 255, 1);display:inline-block;width:100%;line-height:48px;border-radius:6px;color:#fff;text-align:center;font-size:14px;cursor: pointer;">验证访问密码</span>
            </div>
            <div v-if="ifPublic"  style="padding:24px;">
                <div style="position: fixed;width:100%;height:56px;background:#fff;line-height: 56px;left:0;top:0;z-index: 10;">
                    <span style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight: bold;padding-left:24px;">{{basicData.taskName}}</span>
                    <div style="float:right;padding-right:24px;">
                        <a-icon style="color:rgba(121, 136, 155, 1);font-size:14px;margin-right:4px;" type="bank" />
                        <span style="color:rgba(121, 136, 155, 1);font-size:14px;">{{basicData.enterpriseName}}</span>
                    </div>
                </div>
                <div style="background:#fff;border-radius: 4px;padding:20px 24px;margin-top:52px;">
                    <div style="color:rgba(18, 18, 18, 1);font-size:16px;">数据提交</div>
                    <a-textarea
                        v-model="dataValue"
                        placeholder="说明：
                        1.最大支持50000行；
                        2.一行数据一个号码；
                        3.自动提取11位手机号码；
                        4.提交号码自动去重；
                        5.提交后不支持撤回"
                        style="margin-top:20px;"
                        :auto-size="{ minRows: 8, maxRows: 15 }"
                    />
                    <div>
                        <a-checkbox class="filter-data" v-model="ifReduceNumber">
                            是否需要待呼号码去重
                        </a-checkbox>
                        <a-checkbox class="filter-data" v-model="ifFilter">
                            是否需要话单去重
                        </a-checkbox>
                    </div>
                    <div style="margin-top:20px;">
                        <span @click="submitData" style="display: inline-block;width:72px;height: 36px;line-height: 36px;text-align: center;background:rgba(24, 144, 255, 1);border-radius: 4px;color:#fff;background:rgba(24, 144, 255, 1);cursor:pointer;">提交</span>
                    </div>
                </div>
                <div class="revenue-content">
                    <div style="margin-bottom:20px;">
                        <span style="color:rgba(18, 18, 18, 1);font-size:16px;">提交日志</span>
                        <span @click="inputData" style="display: inline-block;padding:0 12px;height: 36px;line-height: 36px;text-align: center;background:rgba(24, 144, 255, 1);border-radius: 4px;color:#fff;background:rgba(24, 144, 255, 1);cursor:pointer;float: right;">导入提交</span>
                    </div>
                    <a-table 
                        bordered 
                        :data-source="userMonthBillList" 
                        :pagination='false'
                        :rowKey="record => record.id"
                    >
                        <!-- <a-table-column key="id" title="提交编号" data-index="id">
                            <template slot-scope="text, record">
                                <div>{{record.id}}</div>
                            </template>
                        </a-table-column> -->
                        <a-table-column key="commitTime" title="提交时间" data-index="commitTime">
                            <template slot-scope="text, record">
                                <div>{{record.commitTime}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="totalCount" title="提交号码数量" data-index="totalCount">
                            <template slot-scope="text, record">
                                <div>{{record.totalCount}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="waitingCallCount" title="待呼号码数量" data-index="waitingCallCount">
                            <template slot-scope="text, record">
                                <div>{{record.waitingCallCount}}</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="status" title="状态" data-index="status">
                            <template slot-scope="text, record">
                                <div v-if="record.status==0">数据导入中</div>
                                <div v-if="record.status==1">呼叫中</div>
                                <div v-if="record.status==2">话单生成中</div>
                                <div v-if="record.status==3">已结束</div>
                                <div v-if="record.status==4">话单生成失败</div>
                            </template>
                        </a-table-column>
                        <a-table-column key="remark" title="备注" data-index="remark" class="remark-content">
                            <template slot-scope="text, record">
                                <!-- <div>{{record.remark}}</div> -->
                                <a-input  class="remark-input" @blur="handleBlur(record.id,record.remark)" v-model="record.remark" style="width:220px;"/>
                            </template>
                        </a-table-column>
                        <a-table-column key="downloadUrl" title="话单下载" data-index="downloadUrl">
                            <template slot-scope="text, record">
                                <div>
                                    <span @click="querySite(record.id)" style="color:rgba(24, 144, 255, 1);margin-right:24px;cursor:pointer;">复制地址</span>
                                    <a v-if="record.status==3" style="cursor:pointer;color:rgba(24, 144, 255, 1);margin-right:24px;" :href="record.downloadUrl" target="_blank">下载成功话单</a>
                                    <!-- <a v-if="record.status==3" style="cursor:pointer;color:rgba(24, 144, 255, 1);margin-right:24px;" :href="record.failRecordDownloadUrl" target="_blank">下载失败话单</a> -->
                                    <a v-if="record.status==3" style="cursor:pointer;color:rgba(24, 144, 255, 1);margin-right:24px;" :href="record.failRecordNoSuccessDownloadUrl" target="_blank">下载失败话单（无成功）</a>
                                    <span v-if="record.status==3||record.status==4" @click="reCreate(record.id)" style="cursor:pointer;color:rgba(24, 144, 255, 1);margin-right:24px;">重新生成</span>
                                    <span v-if="record.status==1||record.status==2" style="color:rgba(158, 172, 196, 1);margin-right:24px;">{{ record.useTimes }}</span>
                                </div>
                            </template>
                        </a-table-column>
                    </a-table>
                    <div style="padding-top:24px;text-align: right">
                        <a-pagination
                            class="pagination-table"
                            show-size-changer
                            :total="totalData"
                            :show-total="totalData => `共 ${totalData} 条     `"
                            v-model="currentPage"
                            @change="pageChange"
                            @showSizeChange="onShowSizeChange"
                        />
                    </div>
                </div>
            </div>
        </div>
        <a-modal title="数据提交确认" :centered='true' :maskClosable='false' v-model.trim="submitModal" footer='' width='480px'>
            <a-divider class="divider2" type="horizontal" style="margin-top:0px;margin-bottom:10px;" />
            <div class="delete-modal modal-public">
                <div class="sure-off-bind">
                    <a-icon type="warning" />
                    <span>你确认要提交{{dataList.length}}条数据吗？</span>
                </div>
                <div class="tip">可选填20字以内备注内容</div>
                <div style="margin-top:12px;">
                    <a-input v-model.trim="remark" placeholder="请输入备注内容" />
                </div>
                <a-divider class="divider2" type="horizontal" />
                <div class="btn-group2">
                    <a-button ghost @click="cancelSubmit">取消</a-button>
                    <a-button :disabled="disabled" type="primary" @click="sureSubmit">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal title="数据提交" :centered='true' :maskClosable='false' v-model.trim="fileUploadModal" footer='' width='600px'>
            <a-divider class="divider2" type="horizontal" style="margin-top:0px;margin-bottom:10px;" />
            <div class="delete-modal modal-public" style="padding-top:12px;">
                <div>
                    <span style="color:rgba(80, 80, 80, 1);font-size:14px">*为保证数据导入顺利，请先</span>
                    <a-button @click="downloadTemplate" icon="download" style="margin-left:8px">
                    下载模板
                    </a-button>
                </div>
                <div style="min-height:166px;margin-top:24px">
                    <a-upload-dragger
                        key={Math.random()}
                        name="file"
                        :multiple="false"
                        :customRequest="customRequest"
                        @change="onUpload"
                        ref="pathClear"
                    >
                        <p class="ant-upload-drag-icon">
                            <a-icon type="upload" />
                        </p>
                        <p class="ant-upload-text">
                            点击或将文件拖拽到这里上传
                        </p>
                        <p class="ant-upload-hint">
                            支持扩展名：.txt .xls .xlsx
                        </p>
                    </a-upload-dragger>
                </div>
                <div>
                    <a-checkbox class="filter-data" v-model="ifNeedReduceNumber">
                        是否需要待呼号码去重
                    </a-checkbox>
                    <a-checkbox class="filter-data" v-model="ifNeedFilter">
                        是否需要话单去重
                    </a-checkbox>
                </div>
                <a-divider class="divider2" type="horizontal" />
                <div class="btn-group2">
                    <a-button ghost @click="cancelNormal">取消</a-button>
                    <a-button type="primary" @click="sureNormal">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="selectNumberModal" title="选择号码-根据条件确定过滤包" footer='' width='600px'>
            <div class="select-number-modal modal-public">
                <a-divider class="divider1" type="horizontal" />
                <div class="select-list">
                    <span class="select-title">最后外呼日期</span>
                    <div class="select-content">
                        <a-input-number v-model="selectNumberObj.lastCallDate" class="select-input" :min="0" :max="90"/>
                        <span>天以内（最大90天）</span>
                    </div>
                </div>
                <div class="select-list">
                    <span class="select-title">最后接听时长</span>
                    <div class="select-content">
                        <a-input-number v-model="selectNumberObj.lastAnswerDuration1" class="select-input" :min="0"/>
                        <span>秒</span>
                        <span style="margin:0 12px">-</span>
                        <a-input-number v-model="selectNumberObj.lastAnswerDuration2" class="select-input" :min="0"/>
                        <span>秒</span>
                    </div>
                </div>
                <a-divider class="divider2" type="horizontal" />
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelSelect">取消</a-button>
                    <a-button type="primary" @click="nextSelect">确认</a-button>
                </div>
            </div>
        </a-modal>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="filterNumberModal" title="选择号码-根据条件确定过滤包" footer='' width='600px'>
            <div class="select-number-modal modal-public">
                <a-divider class="divider1" type="horizontal" />
                <div class="select-list">
                    <span class="select-title">最后外呼日期</span>
                    <div class="select-content">
                        <a-input-number v-model="filterNumberObj.lastCallDate" class="select-input" :min="0" :max="90"/>
                        <span>天以内（最大90天）</span>
                    </div>
                </div>
                <div class="select-list">
                    <span class="select-title">最后接听时长</span>
                    <div class="select-content">
                        <a-input-number v-model="filterNumberObj.lastAnswerDuration1" class="select-input" :min="0"/>
                        <span>秒</span>
                        <span style="margin:0 12px">-</span>
                        <a-input-number v-model="filterNumberObj.lastAnswerDuration2" class="select-input" :min="0"/>
                        <span>秒</span>
                    </div>
                </div>
                <a-divider class="divider2" type="horizontal" />
                <div class="btn-group">
                    <a-button type="primary" ghost @click="cancelFilter">取消</a-button>
                    <a-button type="primary" @click="nextFilter">确认</a-button>
                </div>
            </div>
        </a-modal>
        <textarea id="copyHtml1"></textarea>
    </div>
</template>

<script>
    export default {
        name: 'BillOverview',
        data() {
            return {
                month: '',
                basicData: '',
                ifPublic: false,
                billDetailToken: '',
                proPwd: '',
                phoneLogin: false,
                userMonthBillList: [],
                dataValue: '',
                submitModal: false,
                remark: '',
                dataList: [],
                downloadUrl: '',
                intervalId: null,
                fileUploadModal: false,
                newFormData: '',
                ifNeedReduceNumber: false,
                ifNeedFilter: false,
                selectNumberModal: false,
                senceName: '',
                selectNumberObj: {
                    lastCallDate: null,
                    lastAnswerDuration1: null,
                    lastAnswerDuration2: null,
                },
                ifReduceNumber: false,
                ifFilter: false,
                filterNumberModal: false,
                filterNumberObj: {
                    lastCallDate: null,
                    lastAnswerDuration1: null,
                    lastAnswerDuration2: null,
                },
                disabled: true,
                totalData: 0,
                currentPage: 1,
            }   
        },
        methods: {
            queryBasicData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/waitingCall/external/baseInfo', 
                        params: {
                            externalToken: this.billDetailToken,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.basicData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryShareType() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/waitingCall/external/shareType', 
                        params: {
                            externalToken: this.billDetailToken,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        if(response.data.data.type == 1){
                            this.ifPublic = true
                            this.startFetching();
                            this.queryBasicData()
                            
                        }else{
                            this.ifPublic = false
                        }
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            queryTableData() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/waitingCall/external/commitList', 
                        params: {
                            externalToken: this.billDetailToken,
                            current: this.currentPage,
                            size: this.currentSize,
                        }
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        // console.log(response.data.data)
                        this.userMonthBillList = response.data.data.records
                        this.totalData = response.data.data.total
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            testPwd() {
                this.axios.post('/api/waitingCall/external/valid', {
                    externalToken: this.billDetailToken,
                    password: this.proPwd
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.startFetching();
                        this.ifPublic = true
                        this.queryBasicData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },

            viewBillDetail(url) {
                window.open(url, '_blank');
            },
            viewFailBillDetail(url) {
                window.open(url, '_blank');
            },
            reCreate(id) {
                this.axios(
                    {
                        method:'get',
                        url:'/api/waitingCall/external/regenerate?id='+id, 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('已重新生成');
                        this.queryTableData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            submitData() {
                if(this.dataValue!=''){
                    this.submitModal = true
                    this.disabled = false
                    this.dataList = this.dataValue.split('\n');
                }
            },
            cancelSubmit() {
                this.submitModal = false
            },
            sureSubmit() {
                this.disabled = true
                this.submitModal = false
                if(this.ifFilter == false){
                    this.axios.post('/api/waitingCall/external/import', {
                        externalToken: this.billDetailToken,
                        remark: this.remark,
                        phoneList: this.dataList,
                        removeWaitingCallRepeat: this.ifReduceNumber==false?0:1,
                        removeCallRecordRepeat: this.ifFilter==false?0:1,
                    })
                    .then(response=> {
                        if(response.data.code == 0){
                            this.dataValue = ''
                            this.remark = ''
                            this.ifReduceNumber = false
                            this.ifFilter = false
                            this.queryTableData()
                        }else{
                            this.$message.error(response.data.userTip);
                        }
                    })
                    .catch(error=> {
                        console.log(error)
                    })
                }else{
                    this.filterNumberObj.lastCallDate = ''
                    this.filterNumberObj.lastAnswerDuration1 = ''
                    this.filterNumberObj.lastAnswerDuration2 = ''
                    this.filterNumberModal = true
                }
                // this.axios.post('/api/waitingCall/external/import', {
                //     externalToken: this.billDetailToken,
                //     remark: this.remark,
                //     phoneList: this.dataList
                // })
                // .then(response=> {
                //     if(response.data.code == 0){
                //         this.dataValue = ''
                //         this.remark = ''
                //         this.queryTableData()
                //     }else{
                //         this.$message.error(response.data.userTip);
                //     }
                // })
                // .catch(error=> {
                //     console.log(error)
                // })
            },
            querySite(id) {
                // this.axios(
                //     {
                //         method:'get',
                //         url:'/api/waitingCall/external/downloadUrl', 
                //         params: {
                //             id: id,
                //         }
                //     }
                // )
                // .then(response=> {
                //     if(response.data.code == 0){
                //         this.downloadUrl = response.data.data.callRecordUrl
                //         let text = this.downloadUrl
                //         let input = document.getElementById("copyHtml1");
                //         input.value = text; 
                //         input.select(); 
                //         document.execCommand("copy"); 
                //         this.$message.success('复制成功');
                //     }else{
                //         this.$message.error(response.data.userTip);
                //     }
                // })
                // .catch(error=> {
                //     console.log(error)
                // })
                    this.downloadUrl = 'http://eocc.ixiaowen.net/#/DownloadFile?id='+id
                    // this.downloadUrl = 'http://192.168.1.188:8080/#/DownloadFile?id='+id
                    let text = this.downloadUrl
                    let input = document.getElementById("copyHtml1");
                    input.value = text; 
                    input.select(); 
                    document.execCommand("copy"); 
                    this.$message.success('复制成功');
            },
            startFetching() {
                this.queryTableData(); // 立即请求一次数据
                this.intervalId = setInterval(
                    this.queryTableData, 
                20000); // 每 5 秒请求一次
            },
            stopFetching() {
                clearInterval(this.queryTableData); // 清除定时器
            },
            handleBlur(id ,value) {
                this.axios.post('/api/waitingCall/external/updateRemark', {
                    id: id,
                    remark: value,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.queryTableData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            inputData() {
                this.ifNeedReduceNumber = false,
                this.ifNeedFilter = false,
                this.fileUploadModal = true
            },
            customRequest(data) { // 上传提交
                this.newFormData = new FormData() 
                this.newFormData.append('file', data.file)
                this.newFormData.append('remark', '')
                this.newFormData.append('externalToken', this.billDetailToken)
                // this.newFormData = formData
            },
            onUpload() {
                this.$refs.pathClear.value = ''
            },
            cancelNormal() {
                this.fileUploadModal = false
            },
            sureNormal() {
                this.fileUploadModal = false
                this.newFormData.append('removeWaitingCallRepeat', this.ifNeedReduceNumber==false?0:1)
                if(this.ifNeedFilter==false){
                    this.newFormData.append('removeCallRecordRepeat', 0)
                    this.axios({
                        method: 'post',
                        url: '/api/waitingCall/external/importTxt',
                        headers:{
                            'Content-Type':'application/x-www-form-urlencoded'
                        },
                        data: this.newFormData,
                    
                    }).then((response) => {
                        if(response.data.code == 0){
                            this.newFormData = ''
                            this.queryTableData()
                        }else{
                            this.$message.error(response.data.userTip);
                        }
                    }).catch(function (error) {
                        console.log(error)
                    })
                }else{
                    this.newFormData.append('removeCallRecordRepeat', 1)
                    this.selectNumberObj.lastCallDate = ''
                    this.selectNumberObj.lastAnswerDuration1 = ''
                    this.selectNumberObj.lastAnswerDuration2 = ''
                    this.selectNumberModal = true
                }
               
            },
            cancelSelect() {
                this.selectNumberModal = false
            },
            nextSelect() {
                this.newFormData.append('day', this.selectNumberObj.lastCallDate)
                this.newFormData.append('duration1', this.selectNumberObj.lastAnswerDuration1)
                this.newFormData.append('duration2', this.selectNumberObj.lastAnswerDuration2)
                this.selectNumberModal = false
                this.axios({
                    method: 'post',
                    url: '/api/waitingCall/external/importTxt',
                    headers:{
                        'Content-Type':'application/x-www-form-urlencoded'
                    },
                    data: this.newFormData,
                
                }).then((response) => {
                    if(response.data.code == 0){
                        this.newFormData = ''
                        this.queryTableData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                }).catch(function (error) {
                    console.log(error)
                })
            },
            cancelFilter() {

            },
            nextFilter() {
                this.filterNumberModal = false
                this.axios.post('/api/waitingCall/external/import', {
                    externalToken: this.billDetailToken,
                    remark: this.remark,
                    phoneList: this.dataList,
                    removeWaitingCallRepeat: this.ifReduceNumber==false?0:1,
                    removeCallRecordRepeat: this.ifFilter==false?0:1,
                    day: this.filterNumberObj.lastCallDate,
                    duration1: this.filterNumberObj.lastAnswerDuration1,
                    duration2: this.filterNumberObj.lastAnswerDuration2,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.dataValue = ''
                        this.remark = ''
                        this.ifReduceNumber = false
                        this.ifFilter = false
                        this.queryTableData()
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            onShowSizeChange(current, pageSize) {
                this.currentPage = current
                this.currentSize = pageSize
                this.queryTableData()
            },
            pageChange(current, pageSize) {
                this.currentPage = current
                this.pageSize = pageSize
                this.queryTableData()
            },
            downloadTemplate() {
                window.open('/api/waitingCall/external/download/template?externalToken='+this.billDetailToken, '_blank');
            },
        },
        mounted: function() {
            this.billDetailToken = this.$route.query.billDetailToken
            this.queryShareType()
        },
        beforeDestroy() {
            this.stopFetching(); // 组件销毁前清除定时器
        },
    }
</script>

<style scoped lang="less">
    .revenue-detail{
        height: 100%;
        .pc-content{
            background: rgba(250, 250, 250, 1);
            .revenue-title{
                height: 64px;
                padding: 14px 35px;
                background: #fff;
                box-shadow: 0px 2px 8px 0px rgba(153, 155, 157, 0.08);
                z-index: 10;
                position: fixed;
                width: 100%;
            }
            .revenue-content{
                background: #fff;
                padding: 24px;
                margin-top: 20px;
                box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.04);
                .row-item{
                    margin-top: 16px;
                    .col-item{
                        span:nth-child(1){
                            color: rgba(169, 169, 169, 1);
                            font-size: 12px;
                            display: inline-block;
                            width: 96px;
                        }
                        span:nth-child(2){
                            color: rgba(0, 0, 0, 1);
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        .quality-login{
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            background: #fff;
            .login-box{
                width: 392px;
                height: 180px;
                display: inline-block;
                position: absolute;
                left: 50%;
                margin-left: -196px;
                top: 50%;
                margin-top: -90px;
            }
            .phone-box{
                position: relative;
                background: rgba(4, 17, 26, 1); 
                padding: 160px 24px 0;
                width: 100%;
                height: 100%;
            }
        }
    }
    .delete-modal{
        padding-top: 24px;
        padding-bottom: 48px;
        .sure-off-bind{
            i{
                color: rgba(255, 170, 0, 1);
                font-size: 24px;
            }
            span{
                color: rgba(18, 18, 18, 1);
                font-size: 20px;
                margin-left: 24px;
            }
        }
        .tip{
            color: rgba(80, 80, 80, 1);
            padding-left: 0px;
            margin: 34px 0 12px;
        }
    }
    .modal-public{
        .divider1{
            margin: 0px 0 24px 0;
        }
        .divider2{
            margin: 24px 0 12px;
        }
        .divider3{
            margin: 0px 0 12px;
        }
        .btn-group{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                margin-right: 16px;
            }
        }
        .btn-group2{
            float: right;
            button{
                width: 64px;
                height: 32px;
                font-size: 14px;
            }
            button:nth-child(1){
                background: #fff;
                color: rgba(121, 136, 155, 0.7);
                border: 1px solid rgba(121, 136, 155, 0.5);
                margin-right: 16px;
            }
            button:nth-child(1):hover{
                background: rgba(121, 136, 155, 0.08);
            }
        }
    }
    #copyHtml1{
        position: fixed;
        z-index: -10000;
        left: 1000px;
        top: 1000000px;
    }
    .remark-content{
        .remark-input{
            border:  none;
        }
    }
    .remark-content:hover{
        .remark-input{
            border:  1px solid #ccc;
        }
    }
    .filter-data{
        margin-top: 5px;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
    }
    .select-number-modal{
        height: 190px;
        .select-list{
            color: rgba(80, 80, 80, 1);
            margin-bottom: 12px;
            display: flex;
            line-height: 32px;
            .select-title{
                display: inline-block;
                width: 90px;
            }
            .select-content{
                flex: 1;
                .select-input{
                    width: 120px;
                    margin-right: 12px;
                }
            }
        }
    }
</style>